var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about-us"},[(_vm.page)?[(_vm.$route.query.type !== 'new')?[(_vm.$route.query.type)?_c('custom-breadcrumbs',{attrs:{"name":"page-for-type","params":{ page: _vm.page, type: _vm.$route.query.type }}}):_c('custom-breadcrumbs',{attrs:{"name":"page","params":{ page: _vm.page }}})]:_vm._e(),(_vm.$route.query.type === 'new')?[_c('SimpleBreadcrumbs',{attrs:{"links":[
          {
            name: 'Головна сторінка',
            href: '/'
          },
          {
            name: _vm.page.title,
            href: `/uk/pages/${_vm.page.slug}?type=new`
          }
        ]}})]:_vm._e()]:_vm._e(),_c('page-wrap')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }